<mat-card>
  <mat-card-header>
    @if (antrag.doNotFinishMe) {
      <mat-card-title>{{ 'new_antrag.stepper.label.fourth_step.head.title_draft' | translate }}</mat-card-title>
    } @else {
      <mat-card-title>{{ 'new_antrag.stepper.label.fourth_step.head.title' | translate }}</mat-card-title>
    }
  </mat-card-header>

  <mat-card-content>
    @if (antrag.doNotFinishMe) {
      <p class="translation-text">
        {{ 'new_antrag.stepper.label.fourth_step.head.description_draft' | translate }}
      </p>
    } @else {
      <p class="translation-text">
        {{ 'new_antrag.stepper.label.fourth_step.head.description' | translate }}
      </p>
    }
  </mat-card-content>

  <mat-card-actions align="end" class="mat-card-action-row">
    <button (click)="finishWithRouting()" class="mat-card-action-row__first-button" color="primary" mat-flat-button>
      {{ 'new_antrag.button.new_antrag' | translate }}
    </button>
    <button (click)="finishWithRouting('/antrags-uebersicht')" color="primary" mat-flat-button>
      {{ 'new_antrag.button.antrag_history' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
